/**
 * Frontend-only bundle. Loaded only on the public site, not in the block editor.
 */
import '../../css/frontend-only/index.scss';
import { initTracking } from './statsig-events.js';
import { trackSiteHeaderHeight } from './site-header-offset.js';
import { initTabbedCarouselRefresh } from './tabbed-carousel-refresh.js';
import { initFareHarborIntentDeferral } from './fareharbor-intent-deferral.js';

initTracking();
trackSiteHeaderHeight();
initTabbedCarouselRefresh();
initFareHarborIntentDeferral();
